import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Grid, Header, Divider, Menu, Loader} from 'semantic-ui-react';
import {canViewTeamPage, isAOR, isSAR} from 'go/security/permissions';
import {ENDPOINT_ORGANIZATION} from 'common/endpoints';
import {SET_ORG_ID, SET_DEFAULT_ORG_ID} from 'common/types';
import Main from 'app-ui-componentlibrary/dist/go/components/layout/main';
import OrganizationDropdown from 'go/components/organization/OrganizationDropdown';
import OrganizationAndSamProfileCard from 'go/components/common/OrganizationAndSamProfileCard';
import OrgUsersCardContainer from 'go/components/organization/team/orgUsersCardContainer';
import _ from 'lodash';
import Left from 'go/components/layout/left';
import {Toggle} from 'componentLibrary';
import PermissionsUtility from 'go/security/permissionsUtility';
import {readlink} from 'fs';
import REST from 'go/requests/rest';
import {ORG_MY_PAGE} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';
import {filterByEntityType} from 'common/utils';
import {ENTITY_MAP} from 'app-ui-componentlibrary/dist/common/constants';
import {forceJsonResponse, MONO, FLUX} from 'common/utils';

const MODAL = {
  EDIT: 'edit',
  NONE: 'none',
};
export class OrganizationsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      isLoaded: false,
      data: null,
      selectedOrgId: null,
      editableSummary: false,
      openModal: MODAL.NONE,
      isEditable: false,
      errorPayload: {},
      responseErrorMessage: '',
      activeItem: 'Organizations profile',
      leftExpanded: true,
      orgDefaultValue: '',
      suborgsAllowed: false,
      isSuborgLoaded: false,
      orgId: undefined,
      subOrgId: undefined,
      renderType: undefined,
    };
  }

  componentDidMount() {
    let {orgId, token} = this.props;
    orgId = this.parseOrgId(orgId);
    if (!_.isUndefined(orgId)) this.setState({orgId: orgId});
    const subOrgId = this.props.match.params.subOrgId
      ? this.props.match.params.subOrgId
      : null;
    let renderType = undefined;
    this.props.location.pathname === '/organizationsPage' ||
    this.props.location.pathname === '/organizationsPage/'
      ? (renderType = 'org')
      : (renderType = 'subOrg');
    const urlId =
      renderType === 'org' ? orgId : renderType === 'subOrg' ? subOrgId : null;
    if (urlId) this.getOrgData(orgId, subOrgId, renderType);
    this.setState({
      renderType: renderType,
      urlId: urlId,
      orgId: orgId,
      subOrgId: subOrgId,
    });
    if (_.includes(this.props.toggles, 'manageTeamOrgSubOrg')) {
      this.getUserEntities();
      this.getParentEntities();
    } else {
      let permissionData = new PermissionsUtility(token);
      permissionData.getSubAppOrgs(token).then((res) => {
        !_.isEmpty(res)
          ? this.setState({
              suborgsAllowed: true,
              isSuborgLoaded: true,
            })
          : '';
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    document.title = ORG_MY_PAGE + ' ' + this.state.activeItem;
    let {orgId, location} = this.props;
    let mySubOrgId = _.get(this.props, 'match.params.subOrgId');
    if (!_.isEqual(this.props.match, prevProps.match)) {
      orgId = this.parseOrgId(orgId);
      const subOrgId = this.props.match.params.subOrgId
        ? this.props.match.params.subOrgId
        : null;
      let renderType = undefined;
      this.props.location.pathname === '/organizationsPage' ||
      this.props.location.pathname === '/organizationsPage/'
        ? (renderType = 'org')
        : (renderType = 'subOrg');
      const urlId =
        renderType === 'org' ? orgId : renderType === 'subOrg' ? subOrgId : null;
      if (urlId) {
        this.getOrgData(orgId, subOrgId, renderType);
      }

      this.setState({
        renderType: renderType,
        urlId: urlId,
        orgId: orgId,
        subOrgId: subOrgId,
      });
    }
    if (
      location &&
      prevProps.location &&
      location.key !== prevProps.location.key &&
      !_.isUndefined(mySubOrgId)
    ) {
      this.setState((prevState) => ({
        activeItem: 'Organizations profile',
        selectedOrgId: this.props.defaultOrgId,
      }));
    }
  }

  setDefaultOrg = (_defaultId) => {
    this.props.setDefaultOrgId(_defaultId);
  };

  parseOrgId = (id) => {
    const orgId = _.get(this.props, 'match.params.orgId', id);
    return orgId ? orgId : null;
  };

  getUserEntities = () => {
    this.setState({isLoaded: false}, () => {
      REST.user
        .getEntities(this.props.token)
        .then(REST.handler.handleResponse)
        .then(
          (response) => {
            if (response) {
              const filteredEntities = filterByEntityType(
                response,
                parseInt(ENTITY_MAP.PANEL_REVIEW.code)
              );
              this.setState({
                userEntities: filteredEntities,
                isLoaded: true,
                suborgsAllowed: true,
                isSuborgLoaded: true,
              });
            } else if (response.status === 404) {
              return [];
            } else {
              this.setState({
                error: true,
                isLoaded: true,
              });
            }
          },
          () => {
            // REST.handler.handleResponse returned reject
            this.setState({
              error: true,
              isLoaded: true,
            });
          }
        );
    });
  };

  getParentEntities = () => {
    this.setState({isLoaded: false}, () => {
      REST.user
        .getParentEntities(this.props.token)
        .then(REST.handler.handleResponse)
        .then(
          (response) => {
            if (response) {
              let ids = new Set(
                _.map(response, (result) => {
                  return result.entityId;
                })
              );
              let params;
              const orgId = [];
              if (!ids.isEmpty) {
                params = Array.from(ids).toString();
                orgId.push(params);
              }

              this.setState({
                parentuserEntities: orgId,
                isLoaded: true,
              });
            } else if (response.status === 404) {
              return [];
            } else {
              this.setState({
                error: true,
                isLoaded: true,
              });
            }
          },
          () => {
            // REST.handler.handleResponse returned reject
            this.setState({
              error: true,
              isLoaded: true,
            });
          }
        );
    });
  };

  getOrgData = (orgId, subOrgId, renderType) => {
    this.setState({isLoaded: false, selectedOrgId: orgId});
    let orgPromise;
    if (!renderType || renderType === 'org') {
      orgPromise = REST.organization.getOrganization(this.props.token, orgId);
    } else {
      orgPromise = REST.organization.getSubOrganization(
        this.props.token,
        orgId,
        subOrgId
      );
    }
    return orgPromise
      .then((response) => {
        if (response.ok) {
          return forceJsonResponse(response, MONO);
        } else if (response.status === 404) {
          return [];
        } else {
          this.setState({
            error: true,
            isLoaded: true,
          });
        }
      })
      .then((res) => {
        if (res) {
          this.setState({
            orgData: res,
            isLoaded: true,
          });
        }
      });
  };

  handleOrgChange = (orgId) => {
    const {setOrgId} = this.props;
    const preOrgId = this.props.orgId;
    if (orgId && !_.isEqual(String(orgId), String(preOrgId))) {
      setOrgId(orgId);
      this.getOrgData(orgId, this.props.subOrgId, this.state.renderType);
      this.setState({orgId: orgId});
    }
  };

  handleOrgDropdownError = (error) => {
    this.setState({error: error});
  };

  handleItemClick = (e, {name}) => this.setState({activeItem: name});

  toggleLeft = () => {
    this.setState({leftExpanded: !this.state.leftExpanded});
  };

  render() {
    const {
      orgData,
      selectedOrgId,
      renderType,
      orgId,
      subOrgId,
      activeItem,
      isSuborgLoaded,
      userEntities,
      parentuserEntities,
      isLoaded,
    } = this.state;
    const permissionData = new PermissionsUtility(this.props.token);
    const getParentOrgId = permissionData.getParentOrgIdForSubOrg(selectedOrgId);

    const parentOrgIdForSelectedOrg = !parseInt(getParentOrgId)
      ? selectedOrgId
      : getParentOrgId;
    const isManuallyAdded =
      (!_.isUndefined(orgData) && _.get(orgData, 'isManuallyAdded', 'N')) || 'N';
    const {suborgsAllowed} = this.props;
    const isUserAOR = isAOR(this.props.permissions);
    const isUserAORorSAR = isAOR(this.props.permissions) || isSAR(this.props.permissions);

    let selectedOrgPermission = _.filter(this.props.permissions, (p) => {
      return _.includes(p, subOrgId ? subOrgId : selectedOrgId);
    });
    const orgTeamLabel = renderType === 'org' ? 'Manage my team' : 'Manage user access';
    return (
      <div className="org-details-wrapper">
        <Left expanded={this.state.leftExpanded} toggle={this.toggleLeft}>
          <Menu className="side-nav-menu" vertical borderless>
            <Header
              as="h3"
              title={renderType === 'org' ? 'My organization' : 'My suborganization'}
            >
              {renderType === 'org' ? 'My organization' : 'My suborganization'}
            </Header>
            <Menu.Item
              name={'Organizations profile'}
              active={activeItem === 'Organizations profile'}
              onClick={this.handleItemClick}
              title="Organizations profile"
              tabIndex={0}
              id="content"
            >
              {renderType === 'org' ? 'Organization profile' : 'Suborganization profile'}
            </Menu.Item>
            {((canViewTeamPage(selectedOrgPermission) &&
              renderType === 'org' &&
              isUserAORorSAR) ||
              (renderType === 'subOrg' && isUserAOR)) && (
              <React.Fragment>
                <Menu.Item
                  name={orgTeamLabel}
                  active={activeItem === orgTeamLabel}
                  onClick={this.handleItemClick}
                  title="Manage my team"
                  tabIndex={0}
                >
                  {' '}
                  {orgTeamLabel}{' '}
                </Menu.Item>
                <Menu.Item
                  className="textSmall indent_1"
                  fluid
                  name={'Manage pending registrations'}
                  active={activeItem === 'Manage pending registrations'}
                  onClick={this.handleItemClick}
                  tabIndex={0}
                  title="Manage pending registrations"
                >
                  {'Manage pending registrations'}
                </Menu.Item>
              </React.Fragment>
            )}
            {isSuborgLoaded && suborgsAllowed && (
              <Toggle toggle="mySuborganizations">
                {location.pathname === '/organizationsPage' ||
                location.pathname === '/organizationsPage/' ? (
                  <Header as="h3">My suborganizations</Header>
                ) : (
                  ''
                )}
                <Divider />
                <Menu.Item as={Link} to="/suborganizations" title="All suborganizations">
                  All suborganizations
                </Menu.Item>
              </Toggle>
            )}
          </Menu>
        </Left>
        <Main
          leftOffset={this.state.leftExpanded}
          leftCollapsed={!this.state.leftExpanded}
        >
          <Grid>
            <Grid.Row>
              <Grid.Column width={16} className="org-details">
                {renderType === 'subOrg' &&
                !_.isUndefined(subOrgId) &&
                !_.isUndefined(orgData) &&
                !_.isUndefined(orgData.displayName) ? (
                  <h3 className="card-main-title">{orgData.displayName}</h3>
                ) : !isLoaded ? (
                  <Grid centered>
                    <Grid.Row>
                      <Grid.Column>
                        <Loader inline="centered" active>
                          Loading...
                        </Loader>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                ) : (
                  <OrganizationDropdown
                    type={renderType ? renderType : null}
                    subOrgId={subOrgId}
                    handleOrgChange={(orgId) =>
                      this.handleOrgChange(orgId, subOrgId, renderType)
                    }
                    handleError={(error) => this.handleOrgDropdownError(error)}
                    defaultValue={selectedOrgId}
                    setDefaultOrg={(_defaultOrgId) => this.setDefaultOrg(_defaultOrgId)}
                    defaultOrgNumber={this.props.defaultOrgId}
                    renderType={renderType}
                    {...this.props}
                    userEntities={filterByEntityType(
                      this.state.userEntities,
                      parseInt(ENTITY_MAP.PANEL_REVIEW.code)
                    )}
                  />
                )}
              </Grid.Column>

              {this.state.activeItem === 'Organizations profile' && orgData && (
                <Grid.Column mobile={16} computer={12} className="sam-info-card">
                  {renderType === 'org' ? (
                    <h4 className="underlined-card-label">Organization information</h4>
                  ) : (
                    <h4 className="underlined-card-label">Suborganization information</h4>
                  )}
                  {renderType === 'org' ? (
                    <OrganizationAndSamProfileCard
                      mainLabel={'Organization information'}
                      data={orgData}
                      isLoaded={this.state.isLoaded}
                      isUserAOR={isUserAOR}
                      orgId={orgId}
                      subOrgId={this.props.match.params.subOrgId}
                      handleOrgChange={(orgId) =>
                        this.handleOrgChange(orgId, subOrgId, renderType)
                      }
                    />
                  ) : (
                    <OrganizationAndSamProfileCard
                      mainLabel={'Sub Organization information'}
                      data={orgData}
                      orgId={orgId}
                      subOrgId={this.props.match.params.subOrgId}
                      isUserAOR={isUserAOR}
                      isLoaded={this.state.isLoaded}
                      handleOrgChange={(orgId) =>
                        this.handleOrgChange(orgId, subOrgId, renderType)
                      }
                    />
                  )}
                </Grid.Column>
              )}

              {this.state.activeItem === orgTeamLabel && (
                <Grid.Column mobile={16} computer={16}>
                  {((canViewTeamPage(selectedOrgPermission) && renderType === 'org') ||
                    renderType === 'subOrg') &&
                    isUserAORorSAR && (
                      <OrgUsersCardContainer
                        renderType={subOrgId ? 'subOrg' : 'org'}
                        userId={this.props.id}
                        token={this.props.token}
                        selectedOrgId={subOrgId ? subOrgId : selectedOrgId}
                        parentOrgId={parentOrgIdForSelectedOrg}
                        activeItem={this.state.activeItem}
                        toggles={this.props.toggles}
                        isManuallyAdded={isManuallyAdded}
                        orgData={orgData}
                        userEntities={this.props.userEntities}
                        parentuserEntities={parentuserEntities}
                      />
                    )}
                </Grid.Column>
              )}

              {this.state.activeItem === 'Manage pending registrations' && (
                <Grid.Column mobile={16} computer={16}>
                  {((canViewTeamPage(selectedOrgPermission) && renderType === 'org') ||
                    renderType === 'subOrg') &&
                    isUserAORorSAR && (
                      <OrgUsersCardContainer
                        renderType={subOrgId ? 'subOrg' : 'org'}
                        userId={this.props.id}
                        token={this.props.token}
                        selectedOrgId={subOrgId ? subOrgId : selectedOrgId}
                        parentOrgId={parentOrgIdForSelectedOrg}
                        pending={true}
                        activeItem={this.state.activeItem}
                        toggles={this.props.toggles}
                        isManuallyAdded={isManuallyAdded}
                        userEntities={this.props.userEntities}
                        parentuserEntities={parentuserEntities}
                      />
                    )}
                </Grid.Column>
              )}
            </Grid.Row>
          </Grid>
        </Main>
      </div>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    id: state.auth.userId,
    token: state.auth.token,
    permissions: state.auth.permissions,
    orgId: state.userSessionData.orgId,
    defaultOrgId: state.userSessionData.defaultOrgId,
    toggles: state.toggles.toggles,
    suborgsAllowed: state.userSessionData.suborgsAllowed,
    userEntities: state.userEntities.entitiesData,
  };
};

export const mapDispatchToProps = (dispatch) => ({
  setOrgId: (id) => {
    dispatch({type: SET_ORG_ID, payload: id});
  },
  setDefaultOrgId: (defaultId) => {
    dispatch({type: SET_DEFAULT_ORG_ID, payload: defaultId});
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationsPage);
